import { ApiIntegration, ApiIntegrationUpdate } from '@app/_shared/interfaces/http/api-integration';
import { DataList, DataObject, ErrorObject } from '@app/_shared/interfaces/http/data';
import { createAction, props } from '@ngrx/store';

export const loadIntegrations = createAction(
  '[Integrations] Load Integrations',
  props<{ storeId: string; category?: string }>(),
);

export const loadIntegrationsSuccess = createAction(
  '[Integrations] Load Integrations Success',
  props<DataList<ApiIntegration, null>>(),
);

export const loadIntegrationsFailure = createAction('[Integrations] Load Integrations Failed', props<ErrorObject>());

export const createIntegration = createAction('[Integrations] Create Integration', props<{ data: ApiIntegration }>());

export const createIntegrationSuccess = createAction(
  '[Integrations] Create Integration Succcess',
  props<{ data: DataObject<ApiIntegration> }>(),
);

export const createIntegrationFailed = createAction('[Integrations] Create Integration Failed', props<ErrorObject>());

export const updateIntegration = createAction(
  '[Integrations] Update Integration',
  props<{ id: string; data: ApiIntegrationUpdate }>(),
);

export const updateIntegrationSuccess = createAction(
  '[Integrations] Update Integration Succcess',
  props<{ data: DataObject<ApiIntegration> }>(),
);

export const updateIntegrationFailed = createAction('[Integrations] Update Integration Failed', props<ErrorObject>());

export const setSaving = createAction('[Integrations] Set Saving State', props<{ saving: boolean }>());

export const deleteIntegration = createAction('[Integrations] Delete Integration', props<{ id: number }>());

export const deleteIntegrationSuccess = createAction(
  '[Integrations] Delete Integration Success',
  props<{ id: number }>(),
);

export const deleteIntegrationFailed = createAction('[Integrations] Delete Integration Failed', props<ErrorObject>());

export const clearRequestStates = createAction('[Integrations] Reset All Request States');
